import {AdditionalProps} from 'modules/additionals/types';
import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface AdditionalGroupProps {
  id: string;
  name: string;
  description: string;
  companyId: string;
  company: CompanyProps;
  additionals: AdditionalProps[];
  companyName?: string;
}

export const translatedAdditionalGroupProps: TranslatedKeys<AdditionalGroupProps> =
  {
    description: 'Descrição',
    name: 'Nome (No aplicativo)',
    companyId: 'Empresa',
    company: {...translatedCompanyProps, name: 'Empresa'},
    additionals: 'Adicionais',
    companyName: 'Empresa',
  };
